export default __webpack_public_path__ + "static/media/p1.7456d61d.gif";